// This icon file is generated automatically.
var PEnterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.5.66h-.94a.13.13 0 00-.12.12v8.1h-7.6V7.72c0-.1-.12-.16-.2-.1L.42 9.4a.12.12 0 000 .2l2.22 1.74c.08.07.2 0 .2-.1v-1.17h7.79a1 1 0 001-1V.78a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-enter", "theme": "outlined" };
export default PEnterOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PEnterOutlined.js
// module id = 3354
// module chunks = 0